export default __webpack_public_path__ + "static/media/Background1.74140c3d.png";